import {Model} from "../decorators/model.decorator";
import {Column} from "../decorators/column.decorator";
import {BaseModel} from "./base.model";

@Model('pagination')
export class Pagination<T> extends BaseModel {
  @Column()
  totalPages: number | undefined;
  @Column()
  totalEntries: number | undefined;
  @Column()
  currentPage: number | undefined;
  @Column()
  perPage: number | undefined;
  @Column()
  previousPage: number | undefined;
  @Column()
  nextPage: number | undefined;
}
